import React, { Fragment } from 'react';
import { Badge } from 'components/common';
import PropTypes from 'prop-types';

const BookingEmployeeNameBadgeRenderer = (props) => {

  const {employees} = props.data

  const employeeName = employees && employees.map((emp, index) => (
    <Badge variant='primary' size='sm' key={index} className='tw-mr-1'>{emp.employee_name}</Badge>
  ))

  return (
    <Fragment>
      {employeeName}
    </Fragment>
  );
};

BookingEmployeeNameBadgeRenderer.propTypes = {
  data: PropTypes.object
};

export default BookingEmployeeNameBadgeRenderer;
